module.exports = __webpack_public_path__ + "img/拼多多.e44890b6.png";